import { useMemo } from 'react';
import type { FunnelFilters } from '@/hooks/useFunnelMetrics';
import {
  FunnelTimeComparison,
  FunnelLossAnalysis,
  FunnelConversionByConsultant,
  FunnelConversionBySDR,
  FunnelStageConversion,
} from './funnel';

interface Props {
  businessUnit?: string | null;
  dateFrom?: Date | null;
  dateTo?: Date | null;
}

export default function FunnelAnalyticsSection({ businessUnit, dateFrom, dateTo }: Props) {
  const filters: FunnelFilters = useMemo(() => ({
    businessUnit,
    dateFrom,
    dateTo,
  }), [businessUnit, dateFrom, dateTo]);

  return (
    <div className="space-y-6 mt-8">
      <h2 className="text-xl font-semibold">Análise de Funil</h2>

      {/* Stage Conversion Funnel */}
      <FunnelStageConversion filters={filters} />

      {/* Time Comparison: Won vs Lost */}
      <FunnelTimeComparison filters={filters} />

      {/* Row: Loss Analysis + Consultant Conversion */}
      <div className="grid gap-6 lg:grid-cols-2">
        <FunnelLossAnalysis filters={filters} />
        <FunnelConversionByConsultant filters={filters} />
      </div>

      {/* SDR Conversion */}
      <FunnelConversionBySDR filters={filters} />
    </div>
  );
}
